import React, { useEffect, useRef, useState } from "react";
import { Player } from "bitmovin-player";
import { UIFactory } from "bitmovin-player/bitmovinplayer-ui";
import { fetchPlayApiSource } from "@repo/utils";
import "bitmovin-player/bitmovinplayer-ui.css";

function BitmovinPlayer() {
  const [player, setPlayer] = useState(null);
  const playerDiv = useRef(null);

  const playerConfig = {
    key: "378a99c6-1097-4afa-a8a8-a70762280eb1",
    analytics: {
      key: "3f192444-fe35-4655-9b7d-ae3a30b0bc52",
    },
    ui: false,
    network: {
      preprocessHttpRequest: (type, request) => {
        if (type === "drm/certificate/fairplay") {
          request.responseType = "arraybuffer";
        }
        return Promise.resolve(request);
      },
    },
  };

useEffect(() => {
  let cancelled = false;
  let playerInstance = null;

  async function setupPlayer() {
    try {
      const AdvertisingBitmovinModule = (
        await import("bitmovin-player/modules/bitmovinplayer-advertising-bitmovin")
      ).default;

      let { srcCfg, ads } = await fetchPlayApiSource(
        "https://api.dev.streaming.channel4.com/1.6/A/ENG/DOTCOM/ALL/PLAY/VOD/1000000028",
      );

      // static test ad response
      // BM player wants a full URL so we can't use a relative one
      ads = {
        discardAfterPlayback: false,
        id: "fw-vmap-main",
        position: "pre",
        tag: {
          type: "vmap",
        // url: "https://api.dev.streaming.channel4.com/ad/g/1?prof=174057:c4_hd_html5_dash_live&nw=174055&caid=50726/001&vdur=2710&metr=1023&csid=http://www.channel4.com/4od&vprn=56133&pvrn=46369&resp=vmap1+vast4&vtpo=55&flag=+sltp+emcr+fbad+slcb+nucr+aeti+amcb+scpv+vicb;video_session_id=73070006c654b8ca9db34e3386a222f6a82d74f21643196110154&barbuid2=123&_fw_cookie_consent=1;slid=pre0&ptgt=a&tpos=0&tpcl=PREROLL;slid=mid1&ptgt=a&tpos=625&tpcl=MIDROLL;&cc=0",
          url: "https://samples.dev.streaming.channel4.com/vod-ads-static/vmap-response.xml"
        }
      }

      if (cancelled) return;

      Player.addModule(AdvertisingBitmovinModule);

      if (cancelled) return;
      if (!playerDiv.current) return;

      // avoid mutating a shared config object
      const config = {
        ...playerConfig,
        advertising: {
          adBreaks: [ads],
        },
      };

      playerInstance = new Player(playerDiv.current, config);
      UIFactory.buildDefaultUI(playerInstance);

      await playerInstance.load(srcCfg);

      if (cancelled) return;

      setPlayer(playerInstance);
      console.log("Successfully loaded source");
    } catch (err) {
      if (!cancelled) console.warn(err);
    }
  }

  setupPlayer();

  return () => {
    cancelled = true;

    if (player != null) {
      player.destroy();
      setPlayer(null);
    }
  };
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);


  return <div id="player" ref={playerDiv} />;
}

export default BitmovinPlayer;
